import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoadingColor, LoadingType } from '@constants/loading/1.0';
import { LoadingComponent } from '../loading/1.0/loading.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'txp-loading-dialog',
  templateUrl: './loading-dialog.component.html',
  styleUrls: ['./loading-dialog.component.scss'],
  standalone: true,
  imports: [LoadingComponent, TranslateModule],
})
export class LoadingDialogComponent {
  loadingColor = LoadingColor;
  loadingType = LoadingType;
  constructor(@Inject(MAT_DIALOG_DATA) public data: { label?: string }) {}
}
